module.exports = __webpack_public_path__ + "static/img/c_szpt2b.2347d34.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/c_szpt2b.png
// module id = Jv+A
// module chunks = 73